import React from 'react';
import ReactPlayer from 'react-player'; // Import ReactPlayer
import Header from '../component/Header';
import Footer from '../component/Footer';
import image1 from '../assets/images/laptopdonation.webp'; // Adjust the path as needed
import image2 from '../assets/images/freecourse.webp'; // Adjust the path as needed
import image3 from '../assets/images/hiringjobs.webp'; // Adjust the path as needed
import image4 from '../assets/images/freecourse.webp';

const CharityProgram = () => {
    return (
        <>
            <Header />
            <section className="relative flex justify-center items-center bg-gradient-to-r from-black to-logo text-white md:py-24    py-12 w-full overflow-hidden">

                {/* Content on Top of the Video */}
                <div className="relative z-10 container mx-auto text-center md:px-24 px-6">
                    <h1 className="md:text-5xl text-2xl font-bold mb-4 animate-fadeIn">
                        Charity Program
                    </h1>
                    <p className="mb-6 animate-fadeIn">
                        Empowering dreams, one innovation at a time. We're dedicated to supporting and uplifting individuals in need.
                    </p>
                </div>
            </section>
            <div className='container w-full lg:mb-0 md:mb-12 mb-32 mx-auto md:py-6 py-3'>
                {/* Hero Section with Background Video */}


                {/* About Section */}
                {/* <div className="py-16 md:px-24 px-6">
                    <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div>
                            <img src={require('../assets/images/charity.jpg')} alt="Charity work" className="rounded-lg shadow-lg" />
                        </div>
                        <div className="flex flex-col justify-center">
                            <h2 className="text-3xl font-semibold mb-4">About Our Mission</h2>
                            <p className="text-lg mb-4">
                                Our mission is to provide free and quality IT education to underserved communities. With the rapid growth of technology, we aim to equip individuals with essential skills that will open doors to career opportunities in the IT sector.
                            </p>
                            <p className="text-lg">
                                Through our efforts, we focus on offering coding workshops, providing access to computers, and facilitating mentorship programs that prepare young minds for a bright future in technology.
                            </p>
                        </div>
                    </div>
                </div> */}

                {/* Programs Section */}
                <section className="bg-gray-200 py-16">
                    <div className="relative z-10 container mx-auto text-center md:px-24 px-6">
                        <h1 className="text-4xl font-bold mb-4 animate-fadeIn">
                            AS-Tech Charity Program is launched to support dreams of people and help them in times of need.
                        </h1>
                        <p className="mb-6 animate-fadeIn">
                            This program is only for those who want to express their feelings in their hard times but find no one to hear.
                            This is a supportive hand to let you out of downturns and bring you to the equal level where everyone of us stands.
                            Write us your story, express your passions and feels. Express your troubles. Our agent will reach you out with a solution.
                        </p>
                        <button className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg">
                            Donate Now
                        </button>
                    </div>
                    <div className="container mx-auto text-center md:px-24 px-6">
                        <h2 className="text-3xl font-bold mb-8 animate-fadeIn mt-6">Our Upcoming Projects</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div className="relative bg-white h-60 flex justify-center items-center p-6 rounded-lg shadow-lg hover:shadow-xl transition bg-cover bg-center animate-fadeIn"
                                style={{ backgroundImage: `url(${image1})` }}>
                                <div className="absolute inset-0 bg-black opacity-40 rounded-lg"></div>
                                <div className="relative z-10 p-6">
                                    <h3 className="text-xl font-semibold mb-4 text-white">Old Laptops for Needy</h3>
                                    {/* <p>
                                        We offer intensive coding bootcamps that cover web development, app development, and more. These courses are designed to provide hands-on learning experiences.
                                    </p> */}
                                </div>
                            </div>
                            <div className="relative bg-white h-60 flex justify-center items-center p-6 rounded-lg shadow-lg hover:shadow-xl transition bg-cover bg-center animate-fadeIn"
                                style={{ backgroundImage: `url(${image2})` }}>
                                <div className="absolute inset-0 bg-black opacity-40 rounded-lg"></div>
                                <div className="relative z-10 p-6">
                                    <h3 className="text-xl font-semibold mb-4 text-white">Free Course Enrollment for Needy</h3>
                                    {/* <p>
                                        Our mentorship programs connect students with experienced IT professionals who guide them through learning and career development.
                                    </p> */}
                                </div>
                            </div>
                            <div className="relative bg-white h-60 flex justify-center items-center p-6 rounded-lg shadow-lg hover:shadow-xl transition bg-cover bg-center animate-fadeIn"
                                style={{ backgroundImage: `url(${image3})` }}>
                                <div className="absolute inset-0 bg-black opacity-40 rounded-lg"></div>
                                <div className="relative z-10 p-6">
                                    <h3 className="text-xl font-semibold mb-4 text-white">Jobs Hiring For Talented People</h3>
                                </div>
                            </div>
                            <div className="relative bg-white h-60 flex justify-center items-center p-6 rounded-lg shadow-lg hover:shadow-xl transition bg-cover bg-center animate-fadeIn"
                                style={{ backgroundImage: `url(${image4})` }}>
                                <div className="absolute inset-0 bg-black opacity-40 rounded-lg"></div>
                                <div className="relative z-10 p-6">
                                    <h3 className="text-xl font-semibold mb-4 text-white">Specific Issue Resolvement for Plaintiff</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Call to Action */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 230"><path fill="#1b8ce3" fill-opacity="1" d="M0,160L80,138.7C160,117,320,75,480,96C640,117,800,203,960,218.7C1120,235,1280,181,1360,154.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                <section className="py-16 bg-gradient-to-r from-black to-logo text-white">
                    <div className="container mx-auto text-center md:px-24 px-6">
                        <h2 className="text-3xl font-bold mb-6">Join Us in Making a Difference</h2>
                        <p className="text-lg mb-6">
                            With your help, we can create lasting change by providing IT education to those who need it the most. Your support makes it possible for us to continue our mission.
                        </p>
                        <button className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg">
                            Send Your Query
                        </button>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default CharityProgram;
